import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "popinnerbox"
};
const _hoisted_2 = {
  class: "pophead"
};
const _hoisted_3 = {
  class: "phleft"
};
const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = {
  class: "otherdesc"
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = {
  class: "popconright"
};
const _hoisted_9 = {
  class: "imgcontent"
};
const _hoisted_10 = {
  class: "swiper-wrapper"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "textcontainer"
};
const _hoisted_13 = ["innerHTML"];
const _hoisted_14 = {
  class: "atlasContainer",
  ref: "atlasmap"
};
const _hoisted_15 = {
  class: "popconleft"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
  class: "funbox"
};
const _hoisted_18 = {
  class: "li5"
};
const _hoisted_19 = {
  key: 0,
  class: "li4"
};
const _hoisted_20 = {
  key: 1,
  class: "li2"
};
const _hoisted_21 = {
  key: 2,
  class: "li3"
};
const _hoisted_22 = {
  key: 3,
  class: "li1"
};
const _hoisted_23 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _directive_viewer = _resolveDirective("viewer");
  return _openBlock(), _createElementBlock("div", null, [_ctx.$attrs.popshowflag && _ctx.$attrs.detail ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(["popcontainer-style3", {
      'mobile': _ctx.$attrs.isMobile
    }])
  }, [_createElementVNode("div", {
    class: "popbg",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.closePop && $options.closePop(...args))
  }), _createElementVNode("div", _hoisted_1, [_withDirectives(_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$attrs.detail.place_name), 1), _createElementVNode("div", _hoisted_5, [_ctx.$attrs.detail.route.length > 0 && _ctx.$attrs.detail.route[0].address ? (_openBlock(), _createElementBlock("p", _hoisted_6, [_cache[7] || (_cache[7] = _createElementVNode("span", {
    class: "icon-location1"
  }, null, -1)), _createTextVNode(" " + _toDisplayString(_ctx.$attrs.detail.route[0].address), 1)])) : _createCommentVNode("", true), _ctx.$attrs.detail.telphone !== undefined && _ctx.$attrs.detail.telphone !== '' ? (_openBlock(), _createElementBlock("p", _hoisted_7, [_cache[8] || (_cache[8] = _createElementVNode("span", {
    class: "icon-tel"
  }, null, -1)), _createTextVNode(" " + _toDisplayString(_ctx.$attrs.detail.telphone), 1)])) : _createCommentVNode("", true)])])], 512), [[_vShow, $data.popLeftIndex === 0]]), _createElementVNode("div", {
    class: "closediv",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.closePop && $options.closePop(...args))
  }, _cache[9] || (_cache[9] = [_createElementVNode("span", {
    class: "icon-close"
  }, null, -1)])), _createElementVNode("div", {
    class: _normalizeClass(["popcontent", {
      'tupu': $data.popLeftIndex === 1
    }])
  }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
    class: _normalizeClass(["innerbox", {
      'active': $data.popLeftIndex === 0
    }])
  }, [_withDirectives(_createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
    class: _normalizeClass(["swiper-container swiperbox visibleitem", {
      'on': _ctx.$attrs.detail.currentShowtype === 'banner'
    }]),
    ref: "swipercontainer"
  }, [_createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$attrs.detail.banner, (item, i) => {
    return _withDirectives((_openBlock(), _createElementBlock("div", {
      class: "swiper-slide",
      key: i
    }, [_createElementVNode("img", {
      src: $options.sethandleHttp(item.fileUrl)
    }, null, 8, _hoisted_11), _createElementVNode("h4", null, [_createElementVNode("span", null, _toDisplayString(i + 1), 1), _cache[10] || (_cache[10] = _createTextVNode("/")), _createElementVNode("span", null, _toDisplayString(_ctx.$attrs.detail.banner.length), 1)])])), [[_directive_viewer]]);
  }), 128))])], 2)], 512), [[_vShow, _ctx.$attrs.detail.banner && _ctx.$attrs.detail.banner.length > 0]]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
    class: "infodesc",
    innerHTML: _ctx.$attrs.detail.introduce
  }, null, 8, _hoisted_13)])], 2), _createElementVNode("div", {
    class: _normalizeClass(["innerbox", {
      'active': $data.popLeftIndex === 1
    }])
  }, [_createElementVNode("div", _hoisted_14, null, 512)], 2)])], 2), _createElementVNode("div", _hoisted_15, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.popLeftArr, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass({
        'active': $data.popLeftIndex === item.id
      }),
      key: index,
      onClick: $event => $options.popLeftHandle(item.id)
    }, _toDisplayString(item.name), 11, _hoisted_16);
  }), 128))])]), _withDirectives(_createElementVNode("ul", _hoisted_17, [_createElementVNode("li", _hoisted_18, [_createElementVNode("a", {
    onClick: _cache[2] || (_cache[2] = (...args) => $options.gofind && $options.gofind(...args)),
    target: "_blank"
  }, _cache[11] || (_cache[11] = [_createElementVNode("span", null, null, -1), _createTextVNode("发现")]))]), _ctx.$attrs.detail.portal_link ? (_openBlock(), _createElementBlock("li", _hoisted_19, [_createElementVNode("a", {
    onClick: _cache[3] || (_cache[3] = $event => $options.goLink(_ctx.$attrs.detail.portal_link)),
    target: "_blank"
  }, _cache[12] || (_cache[12] = [_createElementVNode("span", {
    class: "icon-home"
  }, null, -1), _createTextVNode("门户")]))])) : _createCommentVNode("", true), _ctx.$attrs.detail.virtual_link ? (_openBlock(), _createElementBlock("li", _hoisted_20, [_createElementVNode("a", {
    onClick: _cache[4] || (_cache[4] = $event => $options.goLink(_ctx.$attrs.detail.virtual_link)),
    target: "_blank"
  }, _cache[13] || (_cache[13] = [_createElementVNode("span", {
    class: "icon-360"
  }, null, -1), _createTextVNode("全景")]))])) : _createCommentVNode("", true), _ctx.$attrs.detail.special_link ? (_openBlock(), _createElementBlock("li", _hoisted_21, [_createElementVNode("a", {
    onClick: _cache[5] || (_cache[5] = $event => $options.goLink(_ctx.$attrs.detail.special_link)),
    target: "_blank"
  }, _cache[14] || (_cache[14] = [_createElementVNode("span", {
    class: "icon-topic"
  }, null, -1), _createTextVNode("专题")]))])) : _createCommentVNode("", true), _ctx.$attrs.detail.route.length > 0 && _ctx.$attrs.detail.route[0].lng && $data.daohangflag ? (_openBlock(), _createElementBlock("li", _hoisted_22, [_createElementVNode("a", {
    onClick: _cache[6] || (_cache[6] = $event => $options.goLocation(_ctx.$attrs.detail)),
    target: "_blank"
  }, _cache[15] || (_cache[15] = [_createElementVNode("span", {
    class: "icon-location"
  }, null, -1), _createTextVNode("导航")]))])) : _createCommentVNode("", true)], 512), [[_vShow, $data.popLeftIndex === 0]])])], 2)) : _createCommentVNode("", true), _withDirectives(_createElementVNode("iframe", {
    id: "popiframe",
    src: $data.iframeurl,
    frameborder: "0"
  }, null, 8, _hoisted_23), [[_vShow, $data.linkcontainerflag]]), _withDirectives(_createVNode(_component_el_button, {
    class: "goback",
    onClick: $options.goback,
    round: ""
  }, {
    default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode("返回")])),
    _: 1,
    __: [16]
  }, 8, ["onClick"]), [[_vShow, $data.linkcontainerflag]])]);
}